/* Money Reset Challenge page. Slips, sticky bar, video, registration pop-up, UTM pass-through. No tracking. */
(function () {
  if (window.__mrcInit) return;
  window.__mrcInit = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Slips of financial mess: label, value, x and y in the pile (fractions), rotation in degrees.
     Generic on purpose: no real institutions. When the pile settles they line up in this order. */
  var FR = [
    ['Cheque account ···4471', 'R3 204,11', 0.04, 0.06, -7],
    ['Credit card ···8820', 'min. payment due', 0.34, 0, 5],
    ['Store card', 'R12 960,00', 0.12, 0.3, 11],
    ['RA policy 0047-221-9', 'sold to you, 2016', 0.4, 0.22, -4],
    ['Debit order · car insurance', 'R1 842,17', -0.06, 0.5, 3],
    ['Vehicle finance', 'instalment 57 of 72', 0.3, 0.46, -12],
    ['SARS eFiling', 'return outstanding', 0.08, 0.7, -3],
    ['Life cover · policy 2 of 3', 'beneficiary: ?', 0.42, 0.64, 8],
    ['Unit trust (which one?)', 'statement unopened', 0.18, 0.86, -9],
    ['13th cheque', 'gone by February', 0.46, 0.84, 4],
    ['Overdraft', 'R18 000,00 limit', 0.62, 0.1, -6],
    ['School fees · term 3', 'R28 400,00', 0.66, 0.4, 9],
    ['Will', '2014 draft, unsigned', 0.7, 0.72, -5],
    ['Savings pocket 2', 'R640,00', 0.78, 0.26, 6]
  ];
  var clamp = function (n) { return Math.min(1, Math.max(0, n)); };
  var smooth = function (t) { return t * t * (3 - 2 * t); };

  function init() {
    var fields = [].slice.call(document.querySelectorAll('.mrc [data-field]'));
    fields.forEach(function (el) {
      if (el.childElementCount) return;
      var v = el.getAttribute('data-field'), n = +el.getAttribute('data-count') || FR.length, h = '';
      FR.slice(0, n).forEach(function (f, i) {
        h += '<div class="slip slip-' + v + '" style="--cx:' + f[2] + ';--cy:' + f[3] + ';--r:' + f[4] + ';--row:' + i + '"><span>' + f[0] + '</span><span class="v">' + f[1] + '</span></div>';
      });
      el.innerHTML = h;
      var measure = function () {
        var s = el.querySelector('.slip');
        el.style.setProperty('--free', Math.max(el.clientWidth - (s ? s.offsetWidth : 0), 28) + 'px');
        el.style.setProperty('--h', el.clientHeight + 'px');
      };
      measure();
      if (window.ResizeObserver) new ResizeObserver(measure).observe(el);
      /* Reduced motion: the pile under Chaos is shown already settled, the hero stays still. */
      if (reduce) el.style.setProperty('--s', v === 'paper' ? '1' : '0');
    });

    var sticky = document.querySelector('.mrc .sticky');
    var hero = document.querySelector('.mrc [data-hero]');
    var stops = [].slice.call(document.querySelectorAll('.mrc [data-sticky-stop]'));
    var frame = 0;
    function update() {
      frame = 0;
      var vh = window.innerHeight;
      if (!reduce) fields.forEach(function (el) {
        var r = el.getBoundingClientRect(), v = el.getAttribute('data-field');
        var s = v === 'ghost' ? clamp(-r.top / Math.max(r.height, 1)) * 0.4 : smooth(clamp((vh * 0.92 - r.top) / (vh * 0.62)));
        el.style.setProperty('--s', s.toFixed(3));
      });
      if (sticky && hero) {
        var show = hero.getBoundingClientRect().bottom < 0;
        stops.forEach(function (s) { var r = s.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) show = false; });
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
    }
    var onScroll = function () { if (!frame) frame = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    /* Video: nothing loads from the host until the visitor presses play. */
    [].slice.call(document.querySelectorAll('.mrc .vsl[data-src]')).forEach(function (box) {
      var btn = box.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var src = box.getAttribute('data-src'), title = box.getAttribute('data-title') || '';
        if (box.getAttribute('data-kind') === 'mp4') {
          box.innerHTML = '<video src="' + src + '" controls autoplay playsinline></video>';
        } else {
          box.innerHTML = '<iframe src="' + src + '" title="' + title + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
        }
      });
    });
  }

  /* Registration pop-up. Every "Register now" opens it; without JavaScript the links still jump to #register. */
  function openModal(e) {
    var dlg = document.getElementById('mrc-modal');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    if (e) e.preventDefault();
    var f = dlg.querySelector('iframe[data-src]');
    if (f && !f.getAttribute('src')) {
      var src = f.getAttribute('data-src'), p = [];
      new URLSearchParams(location.search).forEach(function (v, k) { if (/^utm_/i.test(k)) p.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
      if (p.length) src += (src.indexOf('?') > -1 ? '&' : '?') + p.join('&');
      f.setAttribute('src', src);
    }
    if (!dlg.open) dlg.showModal();
    document.documentElement.classList.add('mrc-lock');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.mrc [data-register]');
    if (t) return openModal(e);
    var dlg = document.getElementById('mrc-modal');
    if (!dlg || !dlg.open) return;
    if (e.target.closest('[data-close]') || e.target === dlg) dlg.close();
  });
  document.addEventListener('close', function (e) {
    if (e.target && e.target.id === 'mrc-modal') document.documentElement.classList.remove('mrc-lock');
  }, true);
  if (location.hash === '#register') setTimeout(openModal, 300);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__mrcInit = true; init(); });
})();
